import * as React from "react";
import { api, user } from "src/services/api";
import { goToAuth, currentURL } from "src/services/browser";

import Modal from "../../ui/Modal";

interface Props {
    content?: any;
    onClose: Function;
    subtitle?: any;
}

interface State {
}

export default class MustAuth extends React.Component<Props, State> {
    constructor(props) {
        super(props);
            this.state = {
        };
    }
    
    async save() {
    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
  
    render() {
        const { children, content, subtitle } = this.props;
        const { } = this.state;
        
        return (
            <Modal
              open={true}
              backdrop={true}
              icon={"checked_user_filled"}
              className="frontend_MustAuth ecommerce_AcquistiScuola_bigheader"
              onClose={() => this.cancel()}
            >
              <header>
                <h2>
                    <strong>Accedi a Schoolvisor!</strong>
                    {subtitle && <span>{subtitle()}</span>}
                </h2>
                <p>{content()}</p>
              </header>
              <section>
                <div>
                  <a className="btn lg main2" onClick={() => { goToAuth(false, currentURL()) }}><span>Accedi a Schoolvisor</span></a>
                </div>
                <footer>
                    <p>Non hai ancora un account Schoolvisor?</p>
                    <a className="btn sm main2 uc" onClick={() => { goToAuth(true) }}><span>Iscriviti</span></a>
                </footer>
              </section>
            </Modal>
        );
    }
}

export class MustAuthToggler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open || false
        };
    }
    
    render() {
        return (
        <>
            {this.state && this.state.open && 
            <MustAuth onClose={() => this.setState({open: false})} />
            }
            <span onClick={() => this.setState({open: true}) }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/MustAuth.tsx